<template>
  <v-btn
    v-if="buttonConfig"
    @click="buttonConfig.clickHandler"
    :append-icon="buttonConfig.icon"
    :class="buttonConfig.class"
    :color="buttonConfig.color"
    :data-testid="buttonConfig.dataTestId"
    :ripple="false"
    :variant="buttonConfig.variant"
  >
    {{ $bct(buttonConfig.text) }}
  </v-btn>
</template>

<script setup>
import _ from 'lodash';
import useRouterHelper from '@/shared/composables/useRouterHelper';
import { useStore } from 'vuex';

const { updateQuery } = useRouterHelper();
const store = useStore();
const $bct = inject('translator');

const props = defineProps({
  agreement: {
    type: Object,
    default: () => ({}),
  },
});

const buttonConfig = computed(() => {
  if (['Denied', 'Expired'].includes(props.agreement.status)) {
    return {
      icon: 'cancel',
      class: 'opacity-100 cursor-default',
      color: 'error',
      dataTestId: 'denied-agreement-status',
      variant: 'plain',
      text: props.agreement.status,
      clickHandler: () => {},
    };
  }

  if (['Sent', 'Partial'].includes(props.agreement.status)) {
    let nextSignatoryId;
    const orderedSignatures = _.orderBy(props.agreement.signatures, 'ordinal');

    for (const signature of orderedSignatures) {
      if (signature.signed_at) continue;

      nextSignatoryId = signature.signatory_id;
      break;
    }

    if (nextSignatoryId === store.state.profile.id) {
      return {
        icon: null,
        class: null,
        color: 'primary',
        dataTestId: 'outstanding-agreement-status',
        variant: 'flat',
        text: 'Review and sign',
        clickHandler: () => updateQuery({ agreementId: props.agreement.id }),
      };
    }

    return {
      icon: 'schedule',
      class: 'opacity-100 cursor-default',
      color: 'secondary',
      dataTestId: 'awaiting-signature-agreement-status',
      variant: 'plain',
      text: 'Awaiting another signature',
      clickHandler: () => {},
    };
  }

  return {
    icon: 'check',
    class: 'opacity-100',
    color: 'success',
    dataTestId: 'signed-agreement-status',
    variant: 'plain',
    text: 'Signed',
    clickHandler: () => updateQuery({ agreementId: props.agreement.id }),
  };
});
</script>
